import { Switch } from 'react-router-dom';
import { useModuleFeatureFlag } from '@/providers/FeatureFlag.provider';
import ApprovalInboxContainer from './ApprovalInbox/ApprovalInboxContainer';
import ApprovalSettingsContainer from './ApprovalSettings/ApprovalSettingsContainer';
import ApprovalRolesContainer from './ApprovalSettings/ApprovalRoles/ApprovalRolesContainer';

import WorkflowContainer from './ApprovalSettings/Workflow/WorkflowContainer';
import UpdateWorkflowContainer from './ApprovalSettings/Workflow/UpdateWorkFlow/UpdateWorkFlowContainer';
import ApprovalListContainer from './ApprovalList/ApprovalListContainer';
import ProtectedRoute from '../../utils/ProtectedRoute';
import { useLockedFeatures } from '../../providers/LockedFeatures.provider';
import { JSX } from 'react';

const Routes = (): JSX.Element => {
  const lockedFeatures = useLockedFeatures();
  const featureFlags = useModuleFeatureFlag('transactionApproval');

  return (
    <Switch>
      <ProtectedRoute
        isAllowed={!!lockedFeatures.TransactionApprovalWorkflowEnabled && featureFlags.isEnabled && featureFlags.Inbox}
        showPermission
        exact
        path="/transaction-approval/inbox"
        component={ApprovalInboxContainer}
      />
      <ProtectedRoute
        isAllowed={
          !!lockedFeatures.TransactionApprovalWorkflowEnabled && featureFlags.isEnabled && featureFlags.Configuration
        }
        showPermission
        exact
        path="/transaction-approval/configuration"
        component={ApprovalSettingsContainer}
      />
      <ProtectedRoute
        isAllowed={
          !!lockedFeatures.TransactionApprovalWorkflowEnabled && featureFlags.isEnabled && featureFlags.Configuration
        }
        showPermission
        exact
        path="/transaction-approval/configuration/roles"
        component={ApprovalRolesContainer}
      />
      <ProtectedRoute
        isAllowed={
          !!lockedFeatures.TransactionApprovalWorkflowEnabled && featureFlags.isEnabled && featureFlags.Configuration
        }
        showPermission
        exact
        path="/transaction-approval/configuration/workflows"
        component={WorkflowContainer}
      />
      <ProtectedRoute
        isAllowed={
          !!lockedFeatures.TransactionApprovalWorkflowEnabled && featureFlags.isEnabled && featureFlags.Configuration
        }
        showPermission
        exact
        path="/transaction-approval/configuration/workflows/add"
        component={UpdateWorkflowContainer}
      />
      <ProtectedRoute
        isAllowed={
          !!lockedFeatures.TransactionApprovalWorkflowEnabled && featureFlags.isEnabled && featureFlags.Configuration
        }
        showPermission
        exact
        path="/transaction-approval/configuration/workflows/edit/:id"
        component={UpdateWorkflowContainer}
      />
      <ProtectedRoute
        isAllowed={
          !!lockedFeatures.TransactionApprovalWorkflowEnabled && featureFlags.isEnabled && featureFlags.Configuration
        }
        showPermission
        exact
        path="/transaction-approval/approval-list"
        component={ApprovalListContainer}
      />
    </Switch>
  );
};

export default Routes;
